"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _TextInput = require("./TextInput");

var _SimpleSelect = _interopRequireDefault(require("./SimpleSelect"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var propDoc = _objectSpread(_objectSpread({}, _SimpleSelect["default"].propDoc), {}, {
  height: {
    required: false,
    defaultValue: "".concat(_TextInput.DEFAULT_HEIGHT),
    type: "?number",
    description: "Sets the height of the select button. Set to null id you do not want to" + " pin the height"
  },
  error: {
    required: false,
    defaultValue: undefined,
    type: "?boolean",
    description: "If set to true the select will have a red border"
  },
  borderColor: {
    required: false,
    defaultValue: undefined,
    type: "string",
    description: "Border color of the the simple select"
  }
});

var demoProps = {
  options: [{
    value: 1,
    text: "one"
  }, {
    value: 2,
    text: "two"
  }, {
    value: 3,
    text: "three"
  }],
  onSelected: function onSelected() {},
  selectedValue: 2,
  style: {
    minWidth: 120
  },
  showArrow: false
};

var FormSelect = function FormSelect(props) {
  var className = props.className,
      style = props.style,
      hideBorder = props.hideBorder,
      error = props.error,
      remProps = (0, _objectWithoutProperties2["default"])(props, ["className", "style", "hideBorder", "error"]); // prevent hideBorder from being forwarded

  var styles = useStylesheet(props);
  var rootStyle = (0, _styling.css)(style, className, styles.root);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootStyle
  }, /*#__PURE__*/_react["default"].createElement(_SimpleSelect["default"], (0, _extends2["default"])({
    style: {
      flex: 1
    }
  }, remProps, {
    hideBorder: true
  })));
};

var useStylesheet = function useStylesheet(_ref) {
  var height = _ref.height,
      disabled = _ref.disabled,
      hideBorder = _ref.hideBorder,
      error = _ref.error,
      borderColor = _ref.borderColor;

  var _useTheme = (0, _providers.useTheme)(),
      borderPrimary = _useTheme.borderPrimary,
      negative = _useTheme.negative,
      inputBackground = _useTheme.inputBackground;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        height: height === null ? undefined : _TextInput.DEFAULT_HEIGHT,
        border: !hideBorder ? "solid 1px ".concat(error ? negative : borderColor || borderPrimary) : undefined,
        borderRadius: !hideBorder ? 4 : undefined,
        opacity: disabled ? 0.5 : 1,
        paddingLeft: _TextInput.DEFAULT_PADDING,
        // account for no-icon padding in TextInput
        backgroundColor: inputBackground
      }
    });
  }, [height, disabled, hideBorder, error, borderColor, borderPrimary, negative, inputBackground]);
};

FormSelect.propDoc = propDoc;
FormSelect.demoProps = demoProps;

var _default = (0, _mobxReact.observer)(FormSelect);

exports["default"] = _default;